import React, { useState } from "react";
import {
	IonText,
	IonLabel,
	IonIcon,
	IonAvatar,
	IonProgressBar,
	IonImg,
	IonCol,
} from "@ionic/react";
import * as constant from "../../constants";
import { chevronBackOutline, chevronForward } from "ionicons/icons";
import {
	COLLECTIONS,
	getImageUrlFromFireStorage,
	signOut,
	updateDoc,
	uploadImageToFireStorage,
} from "../../firebase";
import { connect } from "react-redux";
import { uploadProfileImage, saveLocationPermissionStatus } from "../../Store/Actions";
import { Camera, CameraOptions } from "@ionic-native/camera";
import firebase from "firebase";
import { isPlatform } from "@ionic/react";
import { ToastMessage } from "../../utils/toastMessage";
import { knowLocationPermission } from "./myAddresses";
import { checkMediaQuery } from "../../utils";
import { shutdownMessanger } from "../../intercom";
import { logout } from "../../Store/Actions/auth";

const Profile: React.FC = (props: any) => {
	const { name } = props;
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const [progress, setProgress] = useState(0);

	React.useEffect(() => {
		// console.log("PROFILE ===== ", props);

		const vehicleProgress = (props.userVehiclesList || []).length ? 30 : 0;
		// const documentProgress = (props.userDocumentsList || []).length ? 30 : 0;
		const currentVehicleDocs = props.userVehiclesList.find(
			(veh: any) => veh.catalogVehicleId === props.sliderCatelogVehicleId
		);
		const documentProgress = (
			(!!currentVehicleDocs && currentVehicleDocs.documentIds) ||
			[]
		).length
			? 30
			: 0;

		setProgress(props.profileCompleteness + vehicleProgress + documentProgress);
	}, [props.userVehiclesList, props.userDocumentsList]);

	const handleFileUpload = async (event: any) => {
		try {
			// console.log("HFU ======");

			const file = event.target.files[0];
			if (
				!["image/png", "image/jpg", "image/jpeg", "image/svg+xml"].includes(file.type)
			) {
				throw Error(constant.PLEASE_UPLOAD_VALID_FORMAT);
			}
			const response = await uploadImageToFireStorage(
				props.uid,
				file,
				file.name,
				"profile"
			);
			const imageUrl: any = await getImageUrlFromFireStorage(
				response.snapshot.metadata.fullPath
			);

			// console.log("65 ======= ", imageUrl);

			const payload = {
				name: props.name,
				email: props.email,
				primaryPhoneNumber: props.primaryPhoneNumber,
				profileImagePath: imageUrl.metadata,
				onBoarding: true,
				gender: props.gender,
				date_of_birth: props.date_of_birth,
				profileCompleteness: props.profileCompleteness,
			};
			await updateDoc(props.uid, payload, COLLECTIONS.USERS);
			await props.uploadProfileImage({
				profileImagePath: imageUrl.metadata,
			});
		} catch (e: any) {
			setToast({
				toastMessage: e.message,
				showToast: true,
				severity: "warning",
			});
		}
	};

	const options: CameraOptions = {
		destinationType: Camera.DestinationType.DATA_URL,
		sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
	};

	const AccessNativeCamera = () => {
		Camera.getPicture(options).then(
			async (imageData) => {
				// console.log("profile Img Upload ======");
				// imageData is either a base64 encoded string or a file URI
				// If it's base64 (DATA_URL):
				let base64Image = "data:image/jpeg;base64," + imageData;
				const file: any = await imageConversion("data:image/jpeg;base64," + imageData);

				const response = await uploadImageToFireStorage(
					props.uid,
					file,
					file.name,
					"profile"
				);
				// console.log("IMG URL ===== ", response);
				// const res: any = await firebase
				//   .storage()
				//   .ref()
				//   .child(`${props.uid}/${"profile"}/${Date.now()}`)
				//   .putString(base64Image, "data_url", { contentType: "image/jpeg" })
				//   .then((snapshot) => {
				//     return snapshot.metadata.fullPath;
				//   });
				const imageUrl: any = await getImageUrlFromFireStorage(response);

				// console.log("107 ======= ", imageUrl);

				const payload = {
					name: props.name,
					email: props.email,
					primaryPhoneNumber: props.primaryPhoneNumber,
					profileImagePath: imageUrl.metadata,
					onBoarding: true,
					gender: props.gender,
					date_of_birth: props.date_of_birth,
					profileCompleteness: 0,
				};
				await updateDoc(props.uid, payload, COLLECTIONS.USERS);
				await props.uploadProfileImage({
					profileImagePath: imageUrl.metadata,
				});
			},
			(err) => {
				console.error(err, "CamError");
			}
		);
	};

	const imageConversion = (imageData: any) => {
		return fetch(imageData)
			.then((res) => res.blob())
			.then(async (blob) => {
				const b: any = blob;
				b.lastModifedDate = new Date();
				b.name = new Date().getTime() + ".jpeg";
				const file = new File([b], "image.png", { type: "image/png" });
				return file;
			});
	};

	return (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			<div className="personal_details_text">
				<div className="personal_details_div wholeApp">
					<div className="personal_details_div_child">
						<img
							src={
								checkMediaQuery()
									? "/images/gray_backarrow.svg"
									: "/images/back_arrow.svg"
							}
							className="back_arrow"
							onClick={() => props.history.push("/portal/dashboard")}
						/>
						<label className="personal_details_labels">{constant.MY_PROFILE}</label>
						<div />
					</div>
				</div>
				<div className={"profile_user"}>
					<div className={"user_circle"} onClick={() => AccessNativeCamera()}>
						<IonAvatar className="user_avatar">
							<img
								src={props.profileImagePath || "/images/profile_default.svg"}
								style={{
									objectFit: "fill",
								}}
							/>
							{(isPlatform("desktop") || isPlatform("mobileweb")) && (
								<input
									accept="image/*"
									type="file"
									className={
										!!props.profileImagePath
											? "input_type_file"
											: "input_type_file margin-top-0-profile"
									}
									onChange={(event: any) => handleFileUpload(event)}
								/>
							)}
						</IonAvatar>
					</div>
					<IonLabel className="profile_name_style">{!!name ? name : ""}</IonLabel>
					<div className="profile_loc_name">
						{(props.userAddressList.length > 0 || !!props.userCurCity) && (
							<img
								src="/images/white_loc_icon.svg"
								className="profile_loc_icon_dimensions"
								//style={{ height: 17, width: 12 }}
							/>
						)}

						<IonLabel className="profile_city">
							{(
								(props.userAddressList || []).find(
									(val: any) =>
										(props.defaultAddressRef || "").split("/").pop() === val.did
								) || {}
							).city ||
								props.storeCity ||
								props.userCurCity}
						</IonLabel>
					</div>
					{!!(props.referalDetails || []).length && (
						<div className="reward-points-details">
							<img src="/images/reward-points.svg" />
							<IonLabel color="light" className="reward-points">
								{props.referalDetails[0].pointsEarned} {constant.REWARD_POINTS}
							</IonLabel>
						</div>
					)}
					<div className="user_text">
						{/* <IonLabel className="user_name">{props.displayName}</IonLabel> */}

						{/* <div className="profile_round">
             <IonIcon icon={star} className="profile_round_icon" />
            <IonLabel className="user_location">135 Reward Points</IonLabel>
          </div>  */}
					</div>
				</div>
				<div className="profile_progress">
					<div className="progres_text">
						<IonText className="profile_completion" color="tertiary">
							{constant.PROFILE_COMPLETION}
						</IonText>
						<IonText className="percentage" color="secondary">
							{progress}
							{"%"}
						</IonText>
					</div>
					<IonProgressBar
						value={progress / 100}
						className={"profile-progress"}
					></IonProgressBar>
					<br />
				</div>
				<div className="user_details">
					<div
						className="user_details_label"
						onClick={() => props.history.push("/portal/edit-profile")}
						// style={{ backgroundColor: "yellow" }}
					>
						<IonText>{constant.PROFILE_DETAILS}</IonText>
						<img src={"/images/proile_forward_icon.svg"} />
						{/* <IonIcon icon={chevronForward}></IonIcon> */}
					</div>
					<div
						className="user_details_label"
						onClick={() => props.history.push("/portal/my-vehicles")}
					>
						<IonText>{constant.PROFILE_VEHICLES}</IonText>
						<img src={"/images/proile_forward_icon.svg"} />
					</div>
					<div
						className="user_details_label"
						onClick={() =>
							props.history.push({
								pathname: "/portal/document-vault",
								state: { fromDocumentVault: true },
							})
						}
					>
						<IonText>{constant.DOCUMENT_VAULT}</IonText>
						<img src={"/images/proile_forward_icon.svg"} />
					</div>
					<div
						className="user_details_label borderForLast"
						// onClick={async () => {
						//   if (
						//     (await knowLocationPermission({ ...props })) ===
						//       constant.DENIED &&
						//     !(props.userAddressList || []).length
						//   ) {
						//     props.history.push("/portal/add-new-address");
						//   } else {
						//     props.history.push("/portal/my-addresses");
						//   }
						// }}
						onClick={() => {
							props.history.push("/portal/my-addresses");
						}}
					>
						<IonText>{constant.MY_ADDRESS}</IonText>
						<img src={"/images/proile_forward_icon.svg"} />
					</div>
					<div
						className="user_details_label border_none webLogoutUi"
						onClick={() => {
							props.logout();
							signOut();
							// shutdownMessanger(); //! uncomment this line to shutdown intercom
						}}
					>
						<IonText>Sign Out</IonText>
					</div>
				</div>
			</div>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
		</IonCol>
	);
};

export default connect(
	({ auth, userInfo, cart }: any) => {
		return {
			...auth,
			...userInfo,
			...cart,
		};
	},
	{ uploadProfileImage, saveLocationPermissionStatus, logout }
)(Profile);
